export default __webpack_public_path__ + "static/media/vm.6287c028.jpeg";